import { useState, useCallback } from 'react';

export const useMerchFilters = () => {
  const [agencyFilter, setAgencyFilter] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');

  const handleAgencyFilterChange = useCallback((value: string) => {
    setAgencyFilter(value);
  }, []);

  const handleCategoryFilterChange = useCallback((value: string) => {
    setCategoryFilter(value);
  }, []);

  return {
    agencyFilter,
    categoryFilter,
    handleAgencyFilterChange,
    handleCategoryFilterChange,
  };
};
